import React from 'react';
import { Trans } from 'react-i18next';
import { HeadingH2, HeadingH3 } from '@components/Text/Heading/Heading.style';
import { BorderBottomLine, LabelColor, ParagraphColor, Spacing } from '@pages/CommonStyle/common.style';
import { DivFlexRow, DivPadding } from '@pages/CommonStyle/commonDiv.style';
import productDescription from '@src/lang/ko/main/product/productDescription';
import { ProductSpecTitle } from './ProductSpec.style';

interface SpecProps {
  productName: string;
}

const ProductSpec: React.FC<SpecProps> = ({ productName }) => {
  return (
    <>
      <Spacing pixel="64" />

      {productDescription[productName].map((itemKey: string, i: number) => {
        const product = productDescription[itemKey]?.[0]; // 실제 데이터 객체 가져오기
        if (!product) return null;

        return (
          <React.Fragment key={`product-${i}`}>
            <HeadingH2 size="small">
              <Trans i18nKey={`productDescription.${itemKey}.0.title`} />
            </HeadingH2>
            <Spacing pixel="4" />
            <LabelColor color="#818181" size="small">
              <Trans i18nKey={`productDescription.${itemKey}.0.serial`} />
            </LabelColor>
            <Spacing pixel="36" />

            {product.spec.map((specData, specIdx: number) => (
              <>
                <ProductSpecTitle padding={'20'}>
                  <HeadingH3 size="xxxsmall">
                    <Trans i18nKey={`productDescription.${itemKey}.0.spec.${specIdx}.title`} />
                  </HeadingH3>
                </ProductSpecTitle>

                {specData.desc.map((specDesc, specDescIdx: number) => (
                  <>
                    <ProductSpecTitle padding={'12'}>
                      <DivFlexRow>
                        <ParagraphColor color="#000" size="medium">
                          <Trans i18nKey={`productDescription.${itemKey}.0.spec.${specIdx}.desc.${specDescIdx}.theme`} />
                        </ParagraphColor>
                        <>&nbsp;</>
                        <ParagraphColor color="#000" size="medium">
                          <Trans i18nKey={`:`} />
                        </ParagraphColor>
                        <>&nbsp;</>
                        <ParagraphColor color="#000" size="medium">
                          <Trans i18nKey={`productDescription.${itemKey}.0.spec.${specIdx}.desc.${specDescIdx}.desc`} />
                        </ParagraphColor>
                      </DivFlexRow>
                    </ProductSpecTitle>
                  </>
                ))}
                <Spacing pixel="16" />
                {specIdx < product.spec.length - 1 && <BorderBottomLine />}
              </>
            ))}
            {i < productDescription[productName].length - 1 && <Spacing pixel="128" />}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default ProductSpec;
